module.exports = __webpack_public_path__ + "img/pic-03.dea3ab39.png";